module.exports = "<div class=\"row\">\n   <!-- Left -->\n  <div class=\"col-md-2\">\n    <setting-component></setting-component>\n  </div>\n\n  <!-- Center -->\n  <div class=\"col-md-6\">\n    <product-component></product-component>\n    <br />\n    <cart-component></cart-component>\n  </div>  \n\n  <!-- Right -->\n  <div class=\"col-md-4\">\n    <admin-component></admin-component>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/admin/Documents/Visual Studio 2017/Projects/VanzAngularEcommerce/src/app/home/home.component.html
// module id = ../../../../../src/app/home/home.component.html
// module chunks = 1